import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Loader from "./components/Loader";
import Header from "./components/Header";
import ResponsiveNav from "./components/ResponsiveNav";
import Home from "./Pages/Home/Home";

const AppStyled = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: var(--background-color-main);
`;

function App() {
  const [loading, setLoading] = useState(true);
  const [mobile, setMobile] = useState(false);

  const toggleNav = () => {
    setMobile(!mobile);
  };
  const mobileFalse = () => {
    setMobile(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  }, []);
  return (
    <AppStyled>
      <Header toggleNav={toggleNav} />
      <ResponsiveNav mobile={mobile} toggleNav={toggleNav} />
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Home mobileFalse={mobileFalse} />
        </div>
      )}
    </AppStyled>
  );
}

export default App;
